import { CheckNotes, InspectionCase } from '../../inspection-cases';

export class SprinklerSystemInstallationMainDto extends InspectionCase {
  certificateNumber?: InspectionCase;
  fireExtinguishingSystemTypes?: InspectionCase;
  waterSupplyDescription?: InspectionCase;
}

export class SprinklerSystemInstallationMain extends SprinklerSystemInstallationMainDto {
  constructor(
    data: SprinklerSystemInstallationMainDto = { title: 'התקנה - כללי' }
  ) {
    super(data);
    this.certificateNumber = new InspectionCase({
      ...data.certificateNumber,
      title: 'במידה וקיים אישור לתכנון, ציין את מספר התעודה'
    });
    this.fireExtinguishingSystemTypes = new InspectionCase({
      ...data.fireExtinguishingSystemTypes,
      title: 'פרט את סוגי מערכות הכיבוי השונים במבנה'
    });
    this.waterSupplyDescription = new InspectionCase({
      ...data.waterSupplyDescription,
      title: 'תאר את מקור אספקת המים המתכנן למערכות המתזים / אביזרי קצה'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.certificateNumber.isApplicable ||
        this.certificateNumber.isPassed) &&
        (!this.fireExtinguishingSystemTypes.isApplicable ||
          this.fireExtinguishingSystemTypes.isPassed) &&
        (!this.waterSupplyDescription.isApplicable ||
          this.waterSupplyDescription.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.certificateNumber.getNotes(),
      ...this.fireExtinguishingSystemTypes.getNotes(),
      ...this.waterSupplyDescription.getNotes()
    ];
  }
}
